"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var AmPmField = /** @class */ (function (_super) {
    __extends(AmPmField, _super);
    function AmPmField(key, isRequired, initialValue) {
        var _this = _super.call(this, key, 'AM/PM', isRequired, [
            new _1.FieldOption('AM', 'am'),
            new _1.FieldOption('PM', 'pm')
        ], 'AM/PM is required', initialValue, _1.FieldType.DropDown) || this;
        _this.key = key;
        _this.setPlaceholderLabel('am');
        return _this;
    }
    return AmPmField;
}(_1.StringDropdownField));
exports.default = AmPmField;
